import { ArrowRight } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import secureflexLogo from "@/assets/secureflex-logo-new.png";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="border-t border-border/50 py-16 bg-muted/20">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-6 text-center">
        <div className="flex flex-col items-center gap-6">
          <div className="flex items-center gap-3">
            <img src={secureflexLogo} alt="SecureFlex Logo" className="h-16 w-16 object-contain drop-shadow-[0_0_20px_hsl(var(--primary)/0.5)]" />
            <span className="text-xl font-bold tracking-[0.2em] text-foreground">SECUREFLEX</span>
          </div>
          <p className="max-w-md text-sm text-muted-foreground leading-relaxed">
            The world's most advanced security patrol management platform. 
            Proactive digital fortress for the modern security age.
          </p>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 text-sm font-semibold tracking-wide text-muted-foreground">
          <a href="#about" className="hover:text-primary transition-colors">About</a>
          <a href="#features" className="hover:text-primary transition-colors">Features</a>
          <a href="#how-it-works" className="hover:text-primary transition-colors">How It Works</a>
          <a href="#pricing" className="hover:text-primary transition-colors">Pricing</a>
          <a href="#faq" className="hover:text-primary transition-colors">FAQ</a>
          <a href="#contact" className="hover:text-primary transition-colors">Contact</a>
        </nav>

        <div className="flex flex-col items-center gap-8 w-full">
          <Button size="lg" asChild className="h-14 px-10 gap-3 rounded-full text-base font-bold gold-glow">
            <Link to="/app">
              Access Dashboard <ArrowRight className="h-5 w-5" />
            </Link>
          </Button>
          
          <div className="flex flex-col items-center gap-4 w-full">
            <div className="flex items-center gap-6 text-[10px] font-bold tracking-[0.2em] text-muted-foreground uppercase">
              <Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link>
              <span className="opacity-30">|</span>
              <Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            </div>
            <p className="text-xs tracking-widest text-muted-foreground/60">
              © {new Date().getFullYear()} SECUREFLEX. PROACTIVE DIGITAL FORTRESS.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
